
import zhizhen from '@/assets/jianjunzhishi/zhuanpan-zhizhen.png'
import zhizhenGray from '@/assets/jianjunzhishi/zhuanpan-zhizhen-gray.png'
import openbg from '@/assets/jifenhuangou/lottery/popup-bg.png'
import config from '@/config'
import { getintegral } from '@/api/user.js'
import { award, isAward } from '@/api/lottery'
import addressPicker from '@/views/components/address-picker2'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'

import { getAddressDefault, addAddress, editAddress } from '@/api/user'
import {
addCreditParty,
relation,
view,
addPartyCount,
cutCreditPartyNum,
cutCreditParty
} from '@/api/jfhl.js'
import { getUserItem, updateuser, add } from '@/api/lottery.js'
export default {
directives: {
TransferDom
},
components: {
XDialog,
XButton,
Group,
XInput,
addressPicker
},
data () {
return {
checkstyle: false,
zhizhen: zhizhen,
times: '', // 答题次数
lotid: 0,
showOpen: false,
openbg: openbg,
prize: '',
start_rotating_degree: 0, // 初始旋转角度
rotate_angle: 0, // 将要旋转的角度
rotate_transition: 'transform 6s ease-in-out', // 初始化选中的过度属性控制
rotate_transition_pointer: 'transform 10s ease-in-out', // 初始化指针过度属性控制
click_flag: true, // 是否可以旋转抽奖
partyid: this.$route.params.partyid,
partyuserid: '',
prizelist: [], // 奖品列表
angle: '', // 转动角度
tablist: [
{
title: '活动规则'
},
{
title: '我的奖品'
}
],
selected: 0,
startTime: '',
endTime: '',
integral: '',
owner_type: config.owner_type,
isclick: false,
zjlist: [],
animate: false,
isAward: 1, // 是否中奖
showAddress: false,
personObj: {
NAME: '',
ADDRESS: '',
MOBILE: '',
CITYID: '',
COUNTYID: '',
PROVINCEID: ''
},
addressValue: [],
addressid: '',
isAddressButton: false,
defautAddress: true
}
},
created () {
this.addcount() 
this.getview() 

this.getAddress()
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
},
top () {
return -this.activeIndex * 30 + 'px'
}
},
watch: {
addressValue: {
handler: function (val) {
this.personObj.PROVINCEID = val[0]
this.personObj.CITYID = val[1]
this.personObj.COUNTYID = val[2]
},
deep: true
}
},
methods: {
getPartyuserid (ADDRESS, cityid, countyid, provinceid) {
add({
userid: this.accountid,
partyid: this.partyid,
linkman: this.personObj.NAME,
phone: this.personObj.MOBILE,
address: ADDRESS,
provinceid: provinceid,
cityid: cityid,
countyid: countyid
}).then(res => {
this.partyuserid = res.obj.partyuserid
})
},

isAddress () {
updateuser({
lotid: this.lotid,
openid: this.userid
}).then(res => {
if (res.obj.isaddress === 2) {
this.isAddressButton = true
} else {
this.isAddressButton = false
}
})
},

getAddress () {
getAddressDefault({
accountid: this.accountid,
userid: this.userid
}).then(res => {
if (res.returnValue !== '') {
this.defautAddress = true
this.personObj = res.returnValue
this.addressid = res.returnValue.ID
console.log(this.personObj)
this.$set(this.addressValue, 0, res.returnValue.PROVINCEID.toString())
this.$set(this.addressValue, 1, res.returnValue.CITYID.toString())
this.$set(this.addressValue, 2, res.returnValue.COUNTYID.toString())
this.personObj.ADDRESS = res.returnValue.ADDRESS
this.getPartyuserid(
this.personObj.ADDRESS,
this.personObj.CITYID,
this.personObj.COUNTYID,
this.personObj.PROVINCEID
)
} else {
this.defautAddress = false
}
})
},

sumbit () {
if (this.personObj.NAME === '') {
this.$vux.toast.text('请填写姓名！')
return false
}
if (this.personObj.ADDRESS === '') {
this.$vux.toast.text('请填写收货地址！')
return false
}
if (this.personObj.MOBILE === '') {
this.$vux.toast.text('请填写手机号码！')
return false
}
if (!/^\d{11}$/.test(this.personObj.MOBILE)) {
this.$vux.toast.text('手机号码格式不对哦～', 'middle')
return false
}
if (!this.defautAddress) {
addAddress({
accountid: this.accountid,
openid: this.openid,
name: this.personObj.NAME,
mobile: this.personObj.MOBILE,
address: this.personObj.ADDRESS,
provinceid: this.personObj.PROVINCEID,
cityid: this.personObj.CITYID,
countyid: this.personObj.COUNTYID,
isdefault: 1
}).then(data => {
if (data.status == 'suc') {
this.getPartyuserid(
this.personObj.ADDRESS,
this.personObj.CITYID,
this.personObj.COUNTYID,
this.personObj.PROVINCEID
)
this.showAddress = false
this.$vux.toast.text('提交成功!')
}
})
} else {
editAddress({
addressid: this.addressid,
accountid: this.accountid,
openid: this.userid,
name: this.personObj.NAME,
mobile: this.personObj.MOBILE,
address: this.personObj.ADDRESS,
provinceid: this.personObj.PROVINCEID,
cityid: this.personObj.CITYID,
countyid: this.personObj.COUNTYID,
isdefault: 1
}).then(data => {
if (data.status == 'suc') {
this.getPartyuserid(
this.personObj.ADDRESS,
this.personObj.CITYID,
this.personObj.COUNTYID,
this.personObj.PROVINCEID
)
this.showAddress = false
this.$vux.toast.text('提交成功!')
}
})
}
},

isawardNow () {
isAward({
lotid: this.lotid,
openid: this.userid
}).then(data => {
if (data.obj.iszhongjiang === 1) {
this.zhizhen = zhizhenGray
this.isAward = 2
this.isclick = true
this.$vux.toast.text('本次活动您已经抽过奖')
} else {
this.isclick = false
this.zhizhen = zhizhen
}
})
},

addcount () {
addPartyCount({
partyid: this.partyid,
accoutid: this.accountid,
credittype: 1
}).then(res => {})
},

addJiFen (credit) {
addCreditParty({
accoutid: this.accountid,
credit: credit,
partyid: this.partyid,
type: 1
}).then(res => {})
},

getActiveNum () {
cutCreditPartyNum({
accoutid: this.accountid
}).then(res => {
if (5 - parseInt(res.obj.num) <= 0) {
this.isclick = true
this.zhizhen = zhizhenGray
this.$vux.alert.show({
content: '您的抽奖次数已经用完'
})
}
})
},

getview () {
view({
id: this.partyid
}).then(res => {
this.lotid = res.obj.lotid
this.paperInfoid = res.obj.paperid
this.startTime = res.obj.signstartdate.replace(/-/g, '/')
this.endTime = res.obj.signenddate.replace(/-/g, '/')
this.isCurrentTime(this.startTime, this.endTime)
this.getWinning()
})
},

isCurrentTime (beginTime, endTime) {
var currentTime = new Date()
var beginTime = new Date(beginTime)
var endTime = new Date(endTime)
if (currentTime < beginTime) {
this.$vux.alert.show({
content: '抽奖活动还未开始'
})
this.isclick = true
this.zhizhen = zhizhenGray
return false
}
if (currentTime >= endTime) {
this.$vux.alert.show({
content: '抽奖活动已结束'
})
this.isclick = true
this.zhizhen = zhizhenGray
return false
}
this.isclick = false

this.isawardNow()
},

cutCredit (credit) {
cutCreditParty({
accoutid: this.accountid,
credit: credit,
partyid: this.partyid
})
},

getintegralTotal () {
getintegral({
accountid: this.accountid,
owner_type: this.owner_type,
userid: this.userid
}).then(res => {
this.integral = res.returnValue.allnow
})
},

go () {
if (!this.isclick) {

if (this.isAward !== 2) {
this.isaward()
this.isclick = true
}
}
},
ontab (index) {
this.selected = index
},

isaward () {
award({
lotid: this.lotid,
openid: this.userid,
lotteryNum: 1
}).then(data => {
if (data.success) {
this.isAward = data.obj.isaward
this.angle = data.obj.angle
this.prize = data.obj.item
if (data.obj.item.indexOf('积分') != -1) {
this.addJiFen(data.obj.item.replace(/[^0-9]/gi, ''))
} else {

relation({
partyuserid: this.partyuserid,
lotid: this.lotid,
userid: this.accountid,
openid: this.userid
}).then(data => {})
}
this.rotating(parseInt(this.angle))
if (data.obj.isaward === 2) {
this.zhizhen = zhizhenGray
}
}
})
},

rotating (degree) {

var type = 0 
var during_time = 5 
var rand_circle = 5 
if (type === 0) {

var rotate_angle =
this.start_rotating_degree +
(360 - (this.start_rotating_degree % 360)) +
rand_circle * 360 +
degree 
this.start_rotating_degree = rotate_angle
this.rotate_angle = 'rotate(' + rotate_angle + 'deg)'

setTimeout(() => {
this.winning()
}, during_time * 1000)
}
},

getWinning () {
getUserItem({
openid: this.userid,
lotid: this.lotid
}).then(res => {
this.prizelist = res.obj.items
})
},

winning () {
setTimeout(() => {
this.showOpen = true
}, 2000)
},

close () {
this.showOpen = false
this.isclick = true
this.zhizhen = zhizhenGray
this.getWinning()
this.getActiveNum()
},
gorule () {
this.$router.push({ name: 'jianjunzhishiRule' })
}
}
}
